import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlantHeart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M15.9,8.44a4.68,4.68,0,0,0-3.9,2.1,4.68,4.68,0,0,0-8.59,2.59c0,7,8.59,9.37,8.59,9.37s8.59-2.34,8.59-9.37A4.69,4.69,0,0,0,15.9,8.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M6.27,1.5H9.14A2.86,2.86,0,0,1,12,4.36v1a0,0,0,0,1,0,0H9.14A2.86,2.86,0,0,1,6.27,2.45v-1A0,0,0,0,1,6.27,1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M14.86,1.5h2.86a0,0,0,0,1,0,0v1a2.86,2.86,0,0,1-2.86,2.86H12a0,0,0,0,1,0,0v-1A2.86,2.86,0,0,1,14.86,1.5Z",
			transform: "translate(29.73 6.82) rotate(-180)"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 10.09,
			x2: 12,
			y2: 5.32
		})
	]
});
const ForwardRef = forwardRef(SvgPlantHeart);
export default ForwardRef;
